/*

미래에셋증권 CI GUIDE 에 따른 색상 규칙
https://securities.miraeasset.com/newir/view/pc/kr/ciguide.jsp

*/

//메인 컬러
export const MAINORANGE = "#F58220";
export const MAINBLUE = "#2563eb";

//blue color
export const BLUE100 = "#1e40af";

//orange color
export const ORNAGE20 = "#F0B26B";

//red
export const DANGER_RED = "#dc2626";

//yello
export const ALERT_YELLOW = "#f59e0b";

//black
export const BLACK100 = "#48535B";
export const BLACK80 = "#84888B";
export const BLACK60 = "#CDCECB";
export const BLACK20 = "#ECEFF4";
